import ProgressBar from "../../../Components/ProgressBar";
import { Animate } from "react-simple-animate";
import {useSelector, useDispatch} from "react-redux";
import {grabToken, logIn} from "../../../../Features/Auth/authSlice";
import {decrementLoginStep} from "../../../../Features/Misc/loginSlice";

export default function PaymentComplete() {

    const dispatch = useDispatch();
    const { email, password, hasActiveSubscription } = useSelector((state) => state.auth)

    const loginData ={
        username: email,
        password
    }

    const handleClick = async () =>{
        if(!hasActiveSubscription){
            dispatch(decrementLoginStep())
            dispatch(decrementLoginStep())
            dispatch(decrementLoginStep())
            dispatch(decrementLoginStep())
            dispatch(decrementLoginStep())
        }
        if(hasActiveSubscription){
            await dispatch(grabToken(loginData))
            await dispatch(logIn(loginData))
        }
    }


    return (

        <div className=" col-start-1 col-end-13 row-start-3 row-end-10 flex text-2xl text-white flex-col gap-4">
            <Animate play start={{opacity: 0}} end={{opacity: 1, display: "flex", flexDirection: "column", gap: "1rem" }} duration={0.7} >
                <div className={`text-2xl`}><p>Sign Up</p></div>
                {hasActiveSubscription && <div className="text-2xl"><p>Payment Complete</p></div>}
                {!hasActiveSubscription && <div className="text-2xl"><p>Improve Your Sleep</p></div>}
                <div className="text-base">
                    {!hasActiveSubscription && <div>Kipmate could help you get that great night sleep you've always dreamt of</div>}
                    {hasActiveSubscription && <div>Thank you for signing up to kipmate. A receipt has been sent to your account email address</div>}
                </div>

                <div className={` flex justify-center  text-2xl `}>
                    <i className="  ri-checkbox-circle-fill text-gold-accent text-6xl"></i>
                </div>

                <div className="flex flex-row gap-4 w-full ">
                    {/*<button className="bg-gold-accent text-xl hover:bg-gold-accent-hover h-14 px-4 py-2 px-8 rounded-lg grow cursor-pointer">Log In to Access Sleep Content</button>*/}
                    {!hasActiveSubscription &&
                        <button onClick={() => handleClick()} className={ `bg-gold-accent text-xl hover:bg-gold-accent-hover h-14 px-4 py-2 px-8 rounded-lg grow cursor-pointer`}>
                            <div>Sign Up For a kipmate Subscription </div>
                        </button>
                    }

                    {hasActiveSubscription &&
                        <button onClick={() => handleClick()} className={ `bg-gold-accent text-xl hover:bg-gold-accent-hover h-14 px-4 py-2 px-8 rounded-lg grow cursor-pointer`}>
                            <div>Log In for Sleep Content </div>
                        </button>
                    }

                </div>

                <ProgressBar width={"w-20"}/>
            </Animate>
        </div>

    );
}